<template>
<div class="column is-full">
    <div v-show="!isEditing">
        <div class="card-header">
            <p class="card-header-title">{{ category.name }} ({{ category.points }})</p>
        </div>
        <div class="card-content">
            <b-taglist>
                <b-tag type="is-link" v-for="item in category.items" v-bind:key="item._id">{{ item.name }}</b-tag>
            </b-taglist>
        </div>
        <footer class="card-footer">
            <a href="#" class="card-footer-item" v-on:click="editCategory()">Edit</a>
            <a href="#" class="card-footer-item" v-on:click="deleteCategory(category)">Delete</a>
        </footer>
    </div>

    <div v-show="isEditing">        
        <div class="card-header">
            <p class="card-header-title">Edit Category</p>
        </div>
        <div class="card-content">
            <div class="content">
                <div class="field">
                    <input class="input is-success" type="text" placeholder="Name" v-model="category.name">
                </div>
                <div class="field">
                    <input class="input is-success" type="number" placeholder="Average Marks" v-model="category.points">
                </div>
                <div class="field">                    
                    <multiselect v-model="category.items" :options="listItem" :close-on-select="false" :multiple="true" :hide-selected="true" label="name" track-by="_id" placeholder="Items"></multiselect>
                </div>
                <div class="field">
                    <slider-picker v-model="category.colour" style="width: 350px !important;" />
                </div>
                <div class="field">
                    <button class='button is-primary' v-on:click="updateCategory(category)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Slider } from 'vue-color'
import Multiselect from 'vue-multiselect'

export default {
    props: ['category','listItem'],
    components:{
        Loading,
        Multiselect,
        'slider-picker': Slider,
    },
    data() {
        return {
            schoolID: "",
            schoolPlan: 1,
            isEditing: false,
            displayStatus: ""
        };
    },
    created() {
    },
    methods: {
        deleteCategory(data) {
            this.$emit('delete-category', data);
        },
        editCategory() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateCategory(data) {
            this.$emit('update-category', data);
            this.isEditing = false;
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Super/CategoryView.vue